import { render, staticRenderFns } from "./UtilDropdownFacet.vue?vue&type=template&id=1b2aa84f&scoped=true"
import script from "./UtilDropdownFacet.vue?vue&type=script&lang=js"
export * from "./UtilDropdownFacet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2aa84f",
  null
  
)

export default component.exports